export const errorMessages = {
  WALLET_CLIENT_UNAVAILABLE: "Wallet client unavailable. Verify chainId.",
};
